<template>
  <section>
    <h2 v-if="sections" class="title-lg text-tertiary60 title-lg pb-2">
      <slot name="title"></slot>
    </h2>
    <h2 v-else class="title-lg text-on-primary-container pb-2">
      <slot name="title"></slot>
    </h2>
    <!-- {{element}} comente esta parte del codigo por que daba conflicto -->
    <div class="body-lg text-neutral20">
      <slot name="content"></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProfileSection',
  props: {
    sections: Boolean,
  },
}
</script>
